export const OWNER = 'OWNER'
export const ADMIN = 'ADMIN'
export const USER = 'USER'

export const ROLES = [OWNER, ADMIN, USER]
